/* --- START: src/components/ContactModal.js --- */
import React, { useState } from 'react';
import ReactDOM from 'react-dom'; // Import ReactDOM
import { supabase } from '../supabaseClient';
import './FeedbackModal.css';

const ContactModal = ({ isOpen, onClose }) => {
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        try {
            const { data: { user } } = await supabase.auth.getUser();

            const { error } = await supabase
                .from('user_feedback')
                .insert([{
                    user_id: user?.id,
                    user_email: user?.email,
                    type: 'question',
                    message: message,
                    status: 'new'
                }]);

            if (error) throw error;

            setMessage('');
            onClose();
            alert("Your question has been sent. Our consultants will reply to your email soon.");
        } catch (error) {
            alert("Connection error. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    // Use createPortal to render outside the App hierarchy
    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose} style={{ zIndex: 5000 }}>
            <div className="feedback-modal theme-aware" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Ask a Consultant</h3>
                    <button className="icon-btn close-btn" onClick={onClose}>&times;</button>
                </div>
                
                <div className="context-banner" style={{borderColor: 'var(--accent-color-primary)'}}>
                    <span className="material-symbols-outlined">headset_mic</span>
                    <span>Stuck on a concept? One of our Bar Exam experts will get back to you.</span>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Your Question</label>
                        <textarea 
                            value={message} 
                            onChange={e => setMessage(e.target.value)} 
                            placeholder="e.g., I'm confused about the difference between Larceny and Embezzlement..."
                            rows="6"
                            required
                        />
                    </div>
                    
                    <div className="modal-actions">
                        <button type="button" className="btn secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="btn" disabled={isSubmitting}>
                            {isSubmitting ? 'Sending...' : 'Send Question'}
                        </button>
                    </div>
                </form>
            </div>
        </div>,
        document.body // Render target
    );
};

export default ContactModal;
/* --- END: src/components/ContactModal.js --- */